module.exports = __webpack_public_path__ + "static/logo_2-c1a4c8f6616107131b3854b49e0560cb.png";